mutation completeUserSwapTransactions($eth_address: String!) {
  completeUserSwapTransactions(eth_address: $eth_address)
}
